"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.subjectShortSchema = void 0;
const lingo2_models_1 = require("lingo2-models");
const zod_1 = require("zod");
exports.subjectShortSchema = zod_1.z.object({
  id: zod_1.z.number(),
  code: zod_1.z.string(),
  title: zod_1.z.string(),
  category_id: zod_1.z.nativeEnum(lingo2_models_1.SubjectCategoryEnum),
  language_id: zod_1.z.number()
});
